<template>
  <div>
    <estudio :documentId="parseInt(documentId)" :projectId="parseInt(projectId)"></estudio>
  </div>
</template>

<script>
import estudio from "@/components/e-studio/EStudio.vue";

export default {
  name: "EStudio",
  props: ["documentId", "projectId"],

  data() {
    return {};
  },
  computed: {},
  components: {
    estudio
  }
};
</script>


